export const TAB_VARIANT = {
  underlined: "underlined",
  tabLike: "tab-like",
};

export const TAB_SIZE = {
  sm: "sm",
};

export const TAB_COLOR = {
  primary: "primary",
  dark: "dark",
  searchSectionPrimary: "search-section-primary",
};
